import { PrivaQueryParamsSearch } from '@priva/components/filter';

import { GreenHouseMap } from 'app/shared/features/map-row-selector/models';

export interface GreenHouseMapFilters {
    mapNumber: number | undefined;
    filteredRowNumbers: number[];
    searchParams: PrivaQueryParamsSearch | undefined;
    recentRowNumber: number | undefined;
}

export interface FilteredGreenHouseMapWithRowNumbers {
    map?: GreenHouseMap;
    filteredRowNumbers: number[];
    recentRowNumber?: number;
}

export const defaultSearchPrivaQueryParamsSearch: PrivaQueryParamsSearch = {
    value: '',
    searchTerms: [],
    properties: {
        fields: [],
    },
};

export const defaultGreenHouseMapFilters: GreenHouseMapFilters = {
    mapNumber: undefined,
    filteredRowNumbers: [],
    searchParams: undefined,
    recentRowNumber: undefined,
};

export interface GreenHouseMapState {
    greenHouseMapList: GreenHouseMap[];
    greenHouseMapFilters: GreenHouseMapFilters;
}

export const initialState: GreenHouseMapState = {
    greenHouseMapList: [],
    greenHouseMapFilters: defaultGreenHouseMapFilters,
};
